import { Dialog, DialogContent, DialogActions, Box } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import { ButtonComp } from 'shared/components/AppComponents';
import { ReactElement } from 'react';

/**
 * Component for the remove client dialog.
 * @param {RemoveClientDialogProps} props - The component props.
 * @returns {ReactElement} React element representing the remove client dialog.
 */
const RemoveClientDialog = ({
    dialogRemove,
    setDialogRemove,
    setStatusPage,
}: RemoveClientDialog): ReactElement => (
    <Dialog
        open={dialogRemove}
        onClose={() => setDialogRemove(false)}
        maxWidth="md"
        className="container-remove-client-dialog"
    >
        <DialogContent dividers className="dialog-content">
            <Box className="dialog-description">
                <Box className="dialog-head">
                    <TypographyLevel variant="one">
                        <Box>
                            Are you sure that you <br />
                            want delete this Checklists?
                        </Box>
                    </TypographyLevel>
                </Box>

                <Box className="dialog-desc">
                    <TypographyLevel variant="three">
                        This action is not reversible.
                        <br />
                        All data regarding this Checklists it will be deleted.
                    </TypographyLevel>
                </Box>
            </Box>
        </DialogContent>

        <DialogActions className="dialog-actions">
            <Box className="dialog-actions-button">
                <ButtonComp
                    width="16rem"
                    onClick={() => {
                        setDialogRemove(false);
                    }}
                    type="neutral"
                >
                    Go back
                </ButtonComp>
                <ButtonComp
                    width="16rem"
                    onClick={() => {
                        setStatusPage('view');
                        setDialogRemove(false);
                    }}
                    type="primary"
                >
                    I'm sure
                </ButtonComp>
            </Box>
        </DialogActions>
    </Dialog>
);

export default RemoveClientDialog;
